import axios from "axios";
import {INTERCOMPANY_LIST_URL} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_STCK_INTERCOMPANY_LIST = 'FETCH_STCK_INTERCOMPANY_LIST'
export const RECEIVE_STCK_INTERCOMPANY_LIST = 'RECEIVE_STCK_INTERCOMPANY_LIST'
export const FAILED_STCK_INTERCOMPANY_LIST = 'FAILED_STCK_INTERCOMPANY_LIST'

export function fetchStckIntercompany(po_number){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_STCK_INTERCOMPANY_LIST});
        axios({
            method: 'post',
            url: INTERCOMPANY_LIST_URL,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            response.data.result.filter(r => r.po_number === po_number)
            dispatch( {
                type: RECEIVE_STCK_INTERCOMPANY_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_INTERCOMPANY_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_INTERCOMPANY_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchStckIntercompanyByPOId(id_purchase_order){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_STCK_INTERCOMPANY_LIST});
        axios({
            method: 'post',
            url: INTERCOMPANY_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_purchase_order
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_INTERCOMPANY_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_INTERCOMPANY_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_INTERCOMPANY_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchStckIntercompanyBySOId(id_sales_order){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_STCK_INTERCOMPANY_LIST});
        axios({
            method: 'post',
            url: INTERCOMPANY_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_sales_order
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_INTERCOMPANY_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_INTERCOMPANY_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_INTERCOMPANY_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_INTERCOMPANY_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}